define([
	"csi/_base/underscore",
	"csi/access/crews",
	"csi/reflection",
	"csi/state/rootStore",
	"csi/xml",
	"csi/page"
], function(_, crews, reflection, {routerStore}, xml, page) {

	return {
		postActionSamplingPlanAcceptanceLimits: function(ac) {
			// summary: refresh the SamplingPlanTable view
			var viewParent = ac.widget.viewParent;
			var view = viewParent ? viewParent.getChildView("SamplingPlanTable") : null;
			if (view) {
				view.refreshData();
			}
		},

		postActionChangeSecurityGroup: function(ac) {
			// summary: when changing security group in Properties View,
			// refresh the tabs view to make teams tab visible or invisible
			// depending on whether inspection is in security group or not
			var viewParent = ac.widget.viewParent;
			if (viewParent) {
				var tabsView = viewParent.viewParent;
				if (tabsView && tabsView.urlRoot == ac.getNodeURL()) {
					tabsView.refreshData();
				}
			}
		},

		postActionChangeState: function(ac) {
			// after state change on the node heading,
			// refresh node and refresh breadcrumb view
			ac.widget.postActionRefreshNode(ac);
			ac.widget.refreshData();
			page.refreshRootView();
		},

		/**
		 * Create New Inspection Batch action is only available under the following conditions:
		 * 1. When the Inspection is "Planned" or "In Progress".
		 * 2. There are no Final Inspection Batches at all or all of the batches are either failed or abandoned.
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessActionNewFinalInspectionBatch: function(ctx, action) {
			const finalInspection = ctx.view.getViewNode();
			const state = xml.enumGetText(finalInspection.InspectionState);

			if (state !== "Planned" && state !== "InProgress") {
				return false;
			}

			return !finalInspection.Batches.some((batchURL) => {
				const batch = ctx.cache.getNode(batchURL);
				return batch && xml.enumGetText(batch.InspectionBatchState) !== "Failed" && xml.enumGetText(batch.InspectionBatchState) !== "Abandoned";
			});
		},

		onAccessActionCreateInspection: function(/*Context*/ctx, /*Action*/action) {
			const node = ctx.getContextNode();

			return crews.isInRoles(["Inspection Administrator", "Inspection Editor", "Inspection Planner"], node);
		},

		onAccessActionReopenInspectionBatch: function(/*Context*/ctx, /*Action*/action) {
			var batch = ctx.getContextNode();

			if (batch) {
				var state = xml.enumGetText(batch.InspectionBatchState);
				if (state != "Passed" && state != "Failed" && state != "Abandoned" && state != "PartiallyPassed") {
					return false;
				}

				var inspection = ctx.cache.getNode(batch.__Parent__);
				var batchIndex = inspection.Batches.indexOf(batch.$URL);
				var lastBatchIndex = inspection.Batches.length - 1;

				if (batchIndex != lastBatchIndex) {// not last Batch
					return false;
				}
			}

			return crews.isInGlobalRoles(["Inspection Library Administrator", "Inspection Administrator"]);

		},

		onAccessActionSaveAsTemplate: function(/*Context*/ctx, /*Action*/action) {
			// Save as Template is available only to Inspection Library Admin
			return crews.isInGlobalRoles(["Inspection Library Administrator"]);
		},
		
		onAccessActionStartInspection: function(/*Context*/ctx, /*Action*/action) {
			return crews.isInRoles(["Inspection Library Administrator", "Inspection Administrator", "Inspection Editor"], ctx.getContextNode());
		},

		/**
		 * Access action to reopen inspection - only Inspection Administrators can reopen
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessActionReopenInspection: function(ctx, action) {
			// C8-33177: Inspection State should not be editable in Matrix
			if (ctx.matrixReadOnly) {
				return false;
			}
			
			// C8-33177: Inspection State should only be editable on FinalInspection nodes or in FinalInspections site level view
			if (!routerStore.locationType.startsWith("FinalInspection") && routerStore.locationType != reflection.TYPE_HOME) {
				return false;
			}	
			
			return crews.isInRoles(["Inspection Administrator"], ctx.getContextNode());
		},

		onAccessActionColorway: function(/*Context*/ctx, /*Action*/action) {
			// allow Colorway actions on template or when inspection in state draft
			var inspectionBOM = ctx.getParent();
			var inspection = ctx.cache.get(inspectionBOM.__Parent__);

			if (inspection.$Type == "InspectionTemplate")
				return true;

			return xml.enumGetText(inspection.InspectionState) == "Draft";
		}
	};
});
